/**
 * React binding for the cookie consent store.
 */

import { useCallback, useSyncExternalStore } from 'react';
import {
  ConsentValue,
  getConsent,
  resetConsent,
  setConsent,
  subscribeConsent,
} from '../utils/cookieConsent';

interface UseCookieConsentResult {
  /** null when the user has not made a decision yet */
  consent: ConsentValue | null;
  accept: () => void;
  decline: () => void;
  reset: () => void;
}

export const useCookieConsent = (): UseCookieConsentResult => {
  const consent = useSyncExternalStore(
    subscribeConsent,
    getConsent,
    () => null
  );

  const accept = useCallback(() => setConsent('granted'), []);
  const decline = useCallback(() => setConsent('denied'), []);
  const reset = useCallback(() => resetConsent(), []);

  return { consent, accept, decline, reset };
};

export default useCookieConsent;
